import { $router } from '../$router/$router'
import { $core } from '../$core'

$core.$router = $router
